import * as React from "react";
import { Button } from "@material-ui/core";
import { ButtonProps } from "@material-ui/core/Button/Button";

export interface IBaseModalActionPros extends ButtonProps  {
    label: string,
    onClick: () => void,
    className?: string
}

export const BaseModalAction:React.FC<IBaseModalActionPros> = (props) => { 
    return (
        <Button 
        type={props.type}
        className={props.className}
        onClick={props.onClick}
        color={props.color} 
        variant={props.variant} >
          {props.label}
        </Button>
    )
}


// WEBPACK FOOTER //
// ./src/component/shared/base-modal/BaseModalAction.tsx